/**
 * @file PPD Purchase constants.
 */

/**
 * Cart Item types.
 *
 * @type {{DOWNLOAD: string, INDIVIDUAL_PRINT: string, PRINT_PACKAGE: string, SUBSCRIPTION: string, ALBUM_CUSTOM_PRINT: string}}
 */
const PPD_CART_ITEM_TYPES = {
  DOWNLOAD: 'DOWNLOAD',
  INDIVIDUAL_PRINT: 'INDIVIDUAL_PRINT',
  PRINT_PACKAGE: 'PRINT_PACKAGE',
  SUBSCRIPTION: 'SUBSCRIPTION',
  ALBUM_CUSTOM_PRINT: 'ALBUM_CUSTOM_PRINT',
};

export { PPD_CART_ITEM_TYPES };
